// This file shared across SB, blog, my-account

import "@/styles/index.scss"

import { Application } from "@hotwired/stimulus"

const application = Application.start()

export { application }
